import { call, put, select, take } from 'redux-saga/effects';
import { get } from 'lodash';

import {
  checkAlreadyCreatedUserAndRedirect,
  redirectToDependentExistPage,
} from './redirect-saga';
import { dependentFormActions } from '../progress.actions';
import * as assignedGuardianListReq from '../assigned-guardian-list-req';
import * as personalInfoReq from '../personal-info-req';
import { selectDependentFormRole } from '../selectors';
import { ERROR_CODES } from '../../../constants/errors';

export function* sendPersonalInfo(dependent) {
  const careRole = yield select(selectDependentFormRole);

  yield put(personalInfoReq.actions.send({ careRole, dependent }));
  /** Wait until success response */
  const { type, payload } = yield take([
    personalInfoReq.consts.SUCCEED,
    personalInfoReq.consts.REJECTED,
  ]);

  if (type === personalInfoReq.consts.REJECTED) {
    yield call(handlePersonalInfoError, payload, dependent);
    return;
  }

  yield put(dependentFormActions.updateDependent(payload));
  yield call(checkAlreadyCreatedUserAndRedirect, payload);
}

function* handlePersonalInfoError(payload, data) {
  const code = get(payload, 'error.code');

  if (code === ERROR_CODES.USER_ALREADY_HAS_GUARDIAN) {
    yield put(assignedGuardianListReq.actions.send(data));
    yield call(redirectToDependentExistPage);
  }
}



// WEBPACK FOOTER //
// ./src/redux/dependentForm/sagas/send-personal-info-saga.js